var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ExpirationCache = /** @class */ (function () {
    function ExpirationCache(storage, utcNow, cacheExpirationInMs, logError) {
        var _this = this;
        this.storage = storage;
        this.utcNow = utcNow;
        this.cacheExpirationInMs = cacheExpirationInMs;
        this.logError = logError;
        this.getValue = function (key, allowStaleData) {
            if (allowStaleData === void 0) { allowStaleData = false; }
            return __awaiter(_this, void 0, void 0, function () {
                var internalValue;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getInternalValue(key, allowStaleData)];
                        case 1:
                            internalValue = _a.sent();
                            return [2 /*return*/, internalValue === null || internalValue === void 0 ? void 0 : internalValue.value];
                    }
                });
            });
        };
        this.getInternalValue = function (key, allowStaleData) {
            if (allowStaleData === void 0) { allowStaleData = false; }
            return __awaiter(_this, void 0, void 0, function () {
                var value, parsedValue, now, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.storage.getItem(key)];
                        case 1:
                            value = _a.sent();
                            if (!value) return [3 /*break*/, 5];
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 3, , 5]);
                            parsedValue = JSON.parse(value);
                            now = this.utcNow();
                            if (allowStaleData || Math.abs(now - parsedValue.createdOnTimestamp) < this.cacheExpirationInMs) {
                                return [2 /*return*/, parsedValue];
                            }
                            return [3 /*break*/, 5];
                        case 3:
                            e_1 = _a.sent();
                            // Delete unparsable item
                            return [4 /*yield*/, this.storage.removeItem(key)];
                        case 4:
                            // Delete unparsable item
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/, null];
                    }
                });
            });
        };
        this.storeValue = function (key, value) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.storage.storeItem(key, JSON.stringify({
                                key: key,
                                createdOnTimestamp: this.utcNow(),
                                value: value
                            }))];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        (_a = this.logError) === null || _a === void 0 ? void 0 : _a.call(this, error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.removeValue = function (key) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storage.removeItem(key)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    }
    return ExpirationCache;
}());
export { ExpirationCache };
